import { SchemaField } from '../../../../../objects/generic/serialization/schema-field';
import { CommunicationsRequestSchema } from '../../generic/communications-request/communications-request-schema';

export class CommunicationsRequestGetSessionIdSchema extends CommunicationsRequestSchema {
  public static readonly callSid = 'callSid';

  public static Defaults = class {
    public static readonly type = undefined;

    public static readonly callSid = undefined;
  };

  public defaultValuesToSerialize(): Set<string> {
    return new Set([]);
  }

  /**
   * Schema for this object is encoded into a command name, and in parameters
   */
  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = super.getSchemaDefinition();

    /* eslint-disable */
    parameters[CommunicationsRequestGetSessionIdSchema.callSid] = SchemaField.string(
      CommunicationsRequestGetSessionIdSchema.Defaults.callSid,
    ).required();
    /* eslint-enable */

    return parameters;
  }
}
